import React from 'react';
import { Box, Skeleton } from '@mui/material';

const TableSkeleton = () => {
  return (
    <Box sx={{ margin: 3 }}>
      {Array.from({ length: 5 }).map((_, index) => (
        <Skeleton
          key={index}
          variant="rectangular"
          height={40}
          animation="wave"
          sx={{ marginBottom: 1 }}
        />
      ))}
    </Box>
  );
};

export default TableSkeleton;
